import withRolloutGuard from '@rover/react-lib/src/components/utils/RolloutGuards';
import { FLAGS } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';
import type PageComponent from '@rover/types/src/PageComponent';

export function withRolloutTrainerSignUp<TProps extends object>(
  Component: PageComponent<TProps>,
  onIneligible: () => JSX.Element | null
): React.ComponentType<TProps> {
  return withRolloutGuard(Component, FLAGS.ROLLOUT_TRAINER_SIGN_UP, onIneligible);
}

export function withRolloutTrainerSignUpGlobal<TProps extends object>(
  Component: PageComponent<TProps>,
  onIneligible: () => JSX.Element | null
): React.ComponentType<TProps> {
  return withRolloutGuard(Component, FLAGS.ROLLOUT_TRAINER_SIGN_UP_GLOBAL, onIneligible);
}

export function withRolloutDogTrainingPilot<TProps extends object>(
  Component: PageComponent<TProps>,
  onIneligible: () => JSX.Element | null
): React.ComponentType<TProps> {
  return withRolloutGuard(Component, FLAGS.ROLLOUT_DOG_TRAINING_PILOT, onIneligible);
}

export function withRolloutVirtualTrainingV1<TProps extends object>(
  Component: PageComponent<TProps>,
  onIneligible: (props: TProps) => JSX.Element | null
): React.ComponentType<TProps> {
  return withRolloutGuard(Component, FLAGS.ROLLOUT_VIRTUAL_TRAINING_V1, onIneligible);
}
